<template>
  <nav
    class="relative flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-gray-700 mb-3"
  >
    <div
      class="container px-4 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start"
      >
        <a
          class="text-xl font-extrabold leading-loose inline-block mr-6 py-2 whitespace-nowrap uppercase text-white tracking-wide shadow-white/30"
          href="#pablo"
        >
          <router-link to="/">HERO-TOOL</router-link>
        </a>
        <div class="block lg:hidden">
          <button
            class="flex items-center px-3 py-2 border rounded text-white border-white-400 hover:text-white hover:border-white"
            @click="toggleNavbar()"
          >
            <svg
              class="fill-current h-5 w-5"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
      </div>
      <div
        :class="showMenu ? 'block' : 'hidden'"
        class="w-full block flex-grow lg:flex lg:items-center lg:w-auto"
      >
        <ul class="flex flex-col lg:flex-row list-none ml-auto">
          <li class="nav-item">
            <a
              class="px-4 py-2 rounded-md flex items-center text-sm uppercase font-semibold leading-tight text-white transition-opacity duration-300 hover:opacity-90 hover:bg-gray-800"
            >
              <router-link to="/">Hem</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="px-4 py-2 rounded-md flex items-center text-sm uppercase font-semibold leading-tight text-white transition-opacity duration-300 hover:opacity-90 hover:bg-gray-800"
            >
              <router-link to="/hero">Testa din hero</router-link>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PinkNavbar',
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleNavbar: function() {
      this.showMenu = !this.showMenu
    }
  }
}
</script>
